export enum TipoVenta{
    indeterminado,
    cabotaje,
    internacional
}